module.exports = __webpack_public_path__ + "img/jet-fighter.02343d0c.svg";